export default __webpack_public_path__ + "static/media/Wi-Fi-kamera_about.a539e2af.webp";